import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Menu } from 'app/shared/models/Menus/menus';
import { Ad } from 'app/shared/models/pub/pub';
import { AdsService } from 'app/shared/services/ads/ads.service';
import { AuthenticationService } from 'app/shared/services/authentification/authentification.service';
import { DataService } from 'app/shared/services/data/data.service';
import { GetlinkService } from 'app/shared/services/getLink/getlink.service';
import { UserService } from 'app/shared/services/user/user.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';


declare const invokeAppAction: any;
@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss']
})
export class HomeContentComponent extends SubscriptionBaseComponent implements OnInit {

  faArrowRight = faArrowRight;

  menu: any[];
  skeleton: ['*', '*', '*', '*', '*', '*'];

  logIn: any;

  refresh = false;
  pub: Ad;
  isConnect: boolean;

  constructor(
    private authentificationService: AuthenticationService,
    private dataService: DataService,
    private userService: UserService,
    private getLinkService: GetlinkService,
    private cdr: ChangeDetectorRef,
    private adsService: AdsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLogIn();
    setTimeout(() => {

      this.initSub();
    }, 2000);
  }

  isMobile(): boolean {
    return this.dataService.isMobile();
  }

  getLink(type: string, title: string, url: string, addPersonas: boolean, addFocntions: boolean, titleHome: string) {
    this.getLinkService.getLink(type, title, url, addPersonas, addFocntions, titleHome);
  }

  invokeAppAction(url: string): void {
    invokeAppAction(url);
  }

  getLinkExternal(menu: Menu): string {
    // this.userService.getLinkExterne(menu.title_Home, menu.addPersona, menu.addFonction).subscribe(res => {
    //   console.log(res);
    //   return res;
    // });
    return menu.url;
  }

  doRefresh(event) {
    this.refresh = true;

    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);

      setTimeout(() => {
        event.target.complete();
        this.refresh = false;
      }, 2000);
    });

  }

  private isLogIn(): void {
    this.logIn = this.dataService.isLogIn(this.authentificationService.currentUserValue);
    this.dataService.logIn.next(this.logIn);
  }

  private addPubInMenus(): void {
    const pub = this.menu.findIndex(item => { if (item.adId) { return item; } });
    this.menu.splice(pub, 1);
    this.adsService.getAdRandom().subscribe(res => {
      if (res) {
        this.menu.splice(1, 0, res);
      }
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.menu.asObservable().subscribe(menu => {
          this.menu = menu;
          console.log(menu);
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.isConnect.asObservable().subscribe(isConnect => {
          this.isConnect = isConnect;
          this.cdr.detectChanges();

        })
      );
    this.addPubInMenus();
  }

}
